import { useEffect, useRef } from 'react';

import { type ScreenName } from '@heidi/runtime/analytics-vocabulary';
import { getOnboardingHost } from '../../../onboarding-host';

/**
 * Fires `screen_viewed` once per mount for a guided-tour screen, matching the
 * other onboarding screens (`onboarding_privacy`, `onboarding_invite_team`) so
 * the treatment's screens sit in the same funnel the control arm reports into.
 *
 * Shared by `TourStepShell` and `TourTranscriptionStep`: the transcription
 * screen needs its own footer and CTA copy so it can't reuse the shell, but it
 * is the first screen of the tour funnel and has to report a view.
 */
export function useTourScreenView(screenName: ScreenName) {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (hasTracked.current) return;
    hasTracked.current = true;
    getOnboardingHost().trackTourScreenViewed(screenName);
  }, [screenName]);
}
